/** Reserved IDs survive admin archive remapping and cannot become editable manuscripts. */
export const AGENT_SOURCE_PREFIX = 'agent-source-';
export const AGENT_SOURCE_FOLDER_ID = '__agent_sources__';
export const AGENT_SOURCE_FOLDER = { id: AGENT_SOURCE_FOLDER_ID, name: 'Agent Sources', parentId: 'none', displayOrder: 1000000 };
export function isAgentSource(id: unknown): id is string {
  return typeof id === 'string' && id.startsWith(AGENT_SOURCE_PREFIX);
}
export function agentSourceEntries(data: any): any[] {
  return (data?.agentSources ?? []).filter((entry: any) => isAgentSource(entry.id));
}
export function withAgentSources(data: any) {
  const sources = agentSourceEntries(data);
  if (!sources.length) return data;
  return { ...data,
    folders: [...(data.folders ?? []).filter((f: any) => f.id !== AGENT_SOURCE_FOLDER_ID), AGENT_SOURCE_FOLDER],
    contents: { ...data.contents, contents: [...(data.contents?.contents ?? []).filter((d: any) => !isAgentSource(d.id)), ...sources] },
  };
}
